import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.ASSET_VERSION}/`;

export const UpdateLiveAssetVersionsAPI = ({ payload, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}live`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
